import config from '@/config/config.json';
export default defineNuxtPlugin({
    name: 'analytics',
    parallel: true,
    async setup() {
        const cookieControl = useCookieControl()
        const {initialize, enableAnalytics} = useGtag()

        if (!cookieControl.isConsentGiven.value ||
            cookieControl.cookiesEnabledIds.value?.includes('google-analytics')
        ) {
            initialize(config.GTAG_ID)
            enableAnalytics(config.GTAG_ID)
        }
    }
});